define(['require', 'jquery', 'mainGtm', 'matchSize'], (require, $, gtm, matchSize) => {
    return {
        topMenu: undefined,
        gtmArea: '',

        init() {
            if (matchSize().desktop) {
                require(['topMenuDesktop'], topMenuDesktop => {
                    this.topMenu = topMenuDesktop;
                    this.gtmArea = 'header';

                    topMenuDesktop.init();
                });
            } else {
                require(['topMenuMobile'], topMenuMobile => {
                    this.topMenu = topMenuMobile;
                    this.gtmArea = 'burger menu';

                    topMenuMobile.init();
                });
            }

            this.initGtmEvent();
        },

        clearText(text) {
            return text.replace(/\s{2,}/g, '');
        },

        getParentCategory(item) {
            return item.parents(this.topMenu.settings.navigationCategoryItem).first();
        },

        getCategoryLink(item) {
            return item.find(this.topMenu.settings.categoryLink).first()
        },

        initGtmEvent() {
            $('.menu-nav').on('click', 'a', el => {
                const target = $(el.target);

                const navItem = $(target.closest(this.topMenu.settings.navigationItem));
                const categoryItem = $(target.closest(this.topMenu.settings.navigationCategoryItem));

                const parentCategory1 = this.getParentCategory(categoryItem);
                const parentCategory2 = this.getParentCategory(parentCategory1);

                const parentLink1 = this.getCategoryLink(parentCategory1);
                const parentLink2 = this.getCategoryLink(parentCategory2);

                let label = this.clearText(target.text());
                if (categoryItem.hasClass(this.topMenu.settings.classItemLevel2)) {
                    label = `${this.clearText(parentLink1.text())}::${label}`;
                }
                if (categoryItem.hasClass(this.topMenu.settings.classItemLevel3)) {
                    label = `${this.clearText(parentLink2.text())}::${this.clearText(parentLink1.text())}::${label}`;
                }

                let navLabel = this.clearText(navItem.find(this.topMenu.settings.navItemLink).text());
                if (navLabel && navLabel !== label) {
                    label = `${navLabel}::${label}`;
                }

                gtm.pushMenuNavigation(this.gtmArea, label);
            });
        },
    };
});
